var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHuman = function SvgHuman(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 60,
    viewBox: "0 0 54 60",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 56.5l0-5.9c0-4.1-1.6-7.9-4.5-10.8 -2.9-2.9-6.7-4.5-10.8-4.5l-23.5 0c-4 0-7.9 1.6-10.8 4.5 -2.9 2.9-4.5 6.8-4.5 10.8l0 5.9c0 1.9 1.6 3.5 3.5 3.5 1.9 0 3.5-1.6 3.5-3.5l0-5.9c0-2.2 0.9-4.3 2.4-5.8 1.5-1.5 3.6-2.4 5.8-2.4 0 0 23.5 0 23.5 0 2.2 0 4.3 0.9 5.8 2.4 1.5 1.5 2.4 3.6 2.4 5.8l0 5.9c0 1.9 1.6 3.5 3.5 3.5 1.9 0 3.5-1.6 3.5-3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.6c8.4 0 15.3-6.8 15.3-15.3 0-8.4-6.8-15.3-15.3-15.3 -8.4 0-15.3 6.8-15.3 15.3 0 8.4 6.8 15.3 15.3 15.3Zm0-7.1c-4.5 0-8.2-3.7-8.2-8.2 0-4.5 3.7-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2 0 4.5-3.7 8.2-8.2 8.2Z"
  })));
};
export default SvgHuman;